export default {
  'component.globalHeader.search': 'Cerca',
  'component.globalHeader.search.example1': 'Esempio di ricerca 1',
  'component.globalHeader.search.example2': 'Esempio di ricerca 2',
  'component.globalHeader.search.example3': 'Esempio di ricerca 3',
  'component.globalHeader.help': 'Aiuto',
  'component.globalHeader.notification': 'Notifica',
  'component.globalHeader.notification.empty':
    'Hai visualizzato tutte le notifiche.',
  'component.globalHeader.message': 'Messaggio',
  'component.globalHeader.message.empty': 'Hai visualizzato tutti i messaggi.',
  'component.globalHeader.event': 'Evento',
  'component.globalHeader.event.empty': 'Hai visualizzato tutti gli eventi.',
  'component.noticeIcon.clear': 'Pulisci',
  'component.noticeIcon.cleared': 'Pulito',
  'component.noticeIcon.empty': 'Nessuna notifica',
  'component.noticeIcon.view-more': 'Visualizza altro',
};
